<template>
    <div class="su" :class="'su--' + variante">
        <button ref="gatilho" type="button" class="su__gatilho" :class="{ 'su__gatilho--aberto': aberto }" @click="alternar()" @keydown.down.prevent="abrir()"
            aria-haspopup="listbox" :aria-expanded="aberto ? 'true' : 'false'" :title="atual ? 'Trocar de unidade' : 'Selecionar unidade'">
            <span class="su__avatar" :style="corAvatar(atual)">{{ atual ? iniciais(atual.nomecompleto) : '' }}<i v-if="!atual" class="fa-solid fa-building-columns"></i></span>
            <span class="su__gatilho-textos">
                <span class="su__gatilho-nome">{{ atual ? atual.nomecompleto : (nomeAtual || 'Selecionar unidade') }}</span>
                <span v-if="variante=='lateral' && atual && atual.empresa" class="su__gatilho-empresa">{{ atual.empresa }}</span>
            </span>
            <i class="fa-solid fa-chevron-down su__seta"></i>
        </button>

        <!-- painel fica no <body>: a barra superior (backdrop-filter) e o menu lateral (overflow) cortariam o posicionamento -->
        <div ref="painel" v-show="aberto" class="su-painel" :style="estiloPainel" role="dialog" aria-label="Trocar de unidade" @keydown="teclado($event)">
            <div class="su-painel__busca">
                <i class="fa-solid fa-magnifying-glass"></i>
                <input ref="busca" v-model="busca" type="search" placeholder="Buscar unidade, código ou empresa" autocomplete="off" spellcheck="false" aria-label="Buscar unidade">
                <kbd v-if="!busca">Esc</kbd>
                <button v-else type="button" class="su-painel__limpar" @click="busca=''; $refs.busca.focus()" aria-label="Limpar busca">&times;</button>
            </div>

            <div ref="lista" class="su-painel__lista" role="listbox">
                <div v-if="carregando" class="su-painel__estado"><span class="spinner-border spinner-border-sm"></span> Carregando unidades...</div>
                <div v-else-if="!itens.length" class="su-painel__estado">
                    <i class="fa-solid fa-magnifying-glass"></i>
                    Nenhuma unidade encontrada para "<b>{{ busca }}</b>"
                </div>
                <template v-else>
                    <div v-for="grupo in grupos" :key="grupo.chave" class="su-grupo">
                        <div class="su-grupo__titulo">
                            <i :class="grupo.recentes ? 'fa-solid fa-clock-rotate-left' : 'fa-solid fa-building'"></i>
                            <span>{{ grupo.titulo }}</span>
                            <span class="su-grupo__contagem">{{ grupo.unidades.length }}</span>
                        </div>
                        <button v-for="item in grupo.unidades" :key="grupo.chave + '-' + item.unidade.id" type="button" role="option"
                            class="su-item" :class="{ 'su-item--foco': item.indice==foco, 'su-item--atual': item.unidade.id==unidadeAtualId }"
                            :aria-selected="item.unidade.id==unidadeAtualId ? 'true' : 'false'" :data-indice="item.indice"
                            @mousemove="foco=item.indice" @click="escolher(item.unidade)">
                            <span class="su__avatar su__avatar--item" :style="corAvatar(item.unidade)">{{ iniciais(item.unidade.nomecompleto) }}</span>
                            <span class="su-item__textos">
                                <span class="su-item__nome" v-html="destacar(item.unidade.nomecompleto)"></span>
                                <span class="su-item__detalhe">
                                    <span v-if="item.unidade.codigounidade" v-html="'Cód. ' + destacar(String(item.unidade.codigounidade))"></span>
                                    <span v-if="grupo.recentes && item.unidade.empresa"> · {{ item.unidade.empresa }}</span>
                                </span>
                            </span>
                            <span v-if="indo==item.unidade.id" class="spinner-border spinner-border-sm su-item__marca"></span>
                            <span v-else-if="item.unidade.id==unidadeAtualId" class="su-item__marca su-item__marca--atual"><i class="fa-solid fa-check"></i> atual</span>
                            <i v-else class="fa-solid fa-arrow-right su-item__marca su-item__ir"></i>
                        </button>
                    </div>
                </template>
            </div>

            <div class="su-painel__rodape">
                <span>{{ unidades.length }} unidade{{ unidades.length==1 ? '' : 's' }}</span>
                <span class="su-painel__atalhos"><kbd>↑</kbd><kbd>↓</kbd> navegar <kbd>Enter</kbd> abrir</span>
            </div>
        </div>
    </div>
</template>

<script>
// a lista é a mesma para a barra superior e o menu lateral: uma requisição só por página
let promessaUnidades = null
function buscarUnidades(){
    if(!promessaUnidades){
        promessaUnidades = axios.get('/api/v1/Companies/Unity/All', { params:{ lista:1 } })
            .then(response => response.data.Unidades || [])
            .catch(error => { console.log(error); promessaUnidades = null; return [] })
    }
    return promessaUnidades
}

const CHAVE_RECENTES = 'ec-unidades-recentes'
const CORES = ['#1a7580','#6f42c1','#c0632b','#2f855a','#2b6cb0','#b83280','#975a16','#1c4d5a']

function normalizar(texto){
    return String(texto || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase()
}
function escapar(texto){
    return String(texto).replace(/[&<>"']/g, c => ({ '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c]))
}
function lerRecentes(){
    try { return JSON.parse(localStorage.getItem(CHAVE_RECENTES)) || [] } catch(e) { return [] }
}
function gravarRecentes(ids){
    try { localStorage.setItem(CHAVE_RECENTES, JSON.stringify(ids.slice(0, 4))) } catch(e) {}
}

export default {
    props:{
        // 'barra' (barra superior, fundo claro) ou 'lateral' (menu lateral, fundo escuro)
        variante:{ type:String, default:'barra' },
        // nome exibido enquanto a lista não chega
        nomeAtual:{ type:String, default:'' },
    },
    data(){
        return{
            unidades:[],
            carregando:false,
            aberto:false,
            busca:'',
            foco:0,
            indo:null,
            recentes:[],
            estiloPainel:{},
        }
    },
    computed:{
        unidadeAtualId(){
            const menu = this.$store ? this.$store.state.menuUnidade : null
            return menu ? menu.id : null
        },
        atual(){
            return this.unidades.find(u => u.id==this.unidadeAtualId) || null
        },
        filtradas(){
            const termo = normalizar(this.busca.trim())
            if(!termo) return this.unidades
            return this.unidades.filter(u => normalizar(u.nomecompleto + ' ' + (u.codigounidade || '') + ' ' + (u.empresa || '')).includes(termo))
        },
        // recentes (sem busca) + unidades agrupadas por empresa; "indice" numera os itens na ordem exibida (teclado)
        grupos(){
            const grupos = []
            let indice = 0
            if(!this.busca.trim()){
                const recentes = this.recentes
                    .filter(id => id!=this.unidadeAtualId)
                    .map(id => this.unidades.find(u => u.id==id))
                    .filter(u => u)
                if(recentes.length && this.unidades.length > 5){
                    grupos.push({ chave:'recentes', titulo:'Acessadas recentemente', recentes:true, unidades:recentes.map(unidade => ({ unidade, indice:indice++ })) })
                }
            }
            this.filtradas.forEach(unidade => {
                const empresa = unidade.empresa || 'Sem empresa'
                let grupo = grupos.find(g => !g.recentes && g.titulo==empresa)
                if(!grupo){
                    grupo = { chave:'e-' + empresa, titulo:empresa, recentes:false, unidades:[] }
                    grupos.push(grupo)
                }
                grupo.unidades.push({ unidade, indice:0 })
            })
            grupos.filter(g => !g.recentes).forEach(g => g.unidades.forEach(item => { item.indice = indice++ }))
            return grupos
        },
        itens(){
            return this.grupos.reduce((lista, g) => lista.concat(g.unidades), []).sort((a, b) => a.indice - b.indice)
        },
    },
    watch:{
        busca(){
            this.foco = 0
            this.$nextTick(() => { if(this.$refs.lista) this.$refs.lista.scrollTop = 0 })
        },
        unidadeAtualId:{
            immediate:true,
            handler(id){
                // a unidade aberta vai para o topo das recentes
                if(id){
                    gravarRecentes([id].concat(lerRecentes().filter(r => r!=id)))
                }
            }
        }
    },
    methods:{
        carregar(){
            this.carregando = !this.unidades.length
            return buscarUnidades().then(unidades => {
                this.unidades = unidades
                this.carregando = false
                this.$emit('carregado', unidades)
            })
        },
        alternar(){
            this.aberto ? this.fechar() : this.abrir()
        },
        abrir(){
            if(this.aberto) return
            this.recentes = lerRecentes()
            this.busca = ''
            this.aberto = true
            this.posicionar()
            this.$nextTick(() => {
                // começa pela unidade atual
                const atual = this.itens.find(i => i.unidade.id==this.unidadeAtualId)
                this.foco = atual ? atual.indice : 0
                this.rolarParaFoco()
                if(this.$refs.busca) this.$refs.busca.focus()
            })
            document.addEventListener('mousedown', this.cliqueFora, true)
            window.addEventListener('resize', this.posicionar)
            window.addEventListener('scroll', this.posicionar, true)
        },
        fechar(devolverFoco){
            if(!this.aberto) return
            this.aberto = false
            document.removeEventListener('mousedown', this.cliqueFora, true)
            window.removeEventListener('resize', this.posicionar)
            window.removeEventListener('scroll', this.posicionar, true)
            if(devolverFoco && this.$refs.gatilho) this.$refs.gatilho.focus()
        },
        cliqueFora(evento){
            if(!this.$refs.painel.contains(evento.target) && !this.$refs.gatilho.contains(evento.target)){
                this.fechar()
            }
        },
        posicionar(){
            const r = this.$refs.gatilho.getBoundingClientRect()
            const margem = 8
            const largura = Math.min(360, window.innerWidth - margem*2)
            const esquerda = Math.max(margem, Math.min(r.left, window.innerWidth - largura - margem))
            const topo = r.bottom + 6
            this.estiloPainel = {
                top: topo + 'px',
                left: esquerda + 'px',
                width: largura + 'px',
                maxHeight: Math.max(240, window.innerHeight - topo - margem) + 'px',
            }
        },
        teclado(evento){
            const total = this.itens.length
            if(evento.key=='ArrowDown'){
                evento.preventDefault()
                if(total){ this.foco = (this.foco + 1) % total; this.rolarParaFoco() }
            }else if(evento.key=='ArrowUp'){
                evento.preventDefault()
                if(total){ this.foco = (this.foco - 1 + total) % total; this.rolarParaFoco() }
            }else if(evento.key=='Enter'){
                evento.preventDefault()
                const item = this.itens.find(i => i.indice==this.foco)
                if(item) this.escolher(item.unidade)
            }else if(evento.key=='Escape'){
                evento.preventDefault()
                this.fechar(true)
            }else if(evento.key=='Tab'){
                this.fechar()
            }
        },
        rolarParaFoco(){
            this.$nextTick(() => {
                const el = this.$refs.lista && this.$refs.lista.querySelector('[data-indice="' + this.foco + '"]')
                if(el) el.scrollIntoView({ block:'nearest' })
            })
        },
        escolher(unidade){
            if(unidade.id==this.unidadeAtualId){
                this.fechar(true)
                return
            }
            this.indo = unidade.id
            gravarRecentes([unidade.id].concat(lerRecentes().filter(r => r!=unidade.id)))
            window.location.href = '/Access/Unity/Unitie/' + unidade.id
        },
        iniciais(nome){
            const palavras = normalizar(nome).replace(/[^a-z0-9\s]/g, ' ').split(/\s+/)
                .filter(p => p.length > 2 || /\d/.test(p))
            return ((palavras[0] || '?')[0] + (palavras[1] ? palavras[1][0] : '')).toUpperCase()
        },
        corAvatar(unidade){
            if(!unidade) return {}
            return { background: CORES[Number(unidade.id) % CORES.length] }
        },
        destacar(texto){
            const termo = this.busca.trim()
            const seguro = escapar(texto)
            if(!termo) return seguro
            // procura sem acento e destaca o trecho original
            const posicao = normalizar(texto).indexOf(normalizar(termo))
            if(posicao < 0) return seguro
            return escapar(texto.slice(0, posicao)) + '<mark>' + escapar(texto.slice(posicao, posicao + termo.length)) + '</mark>' + escapar(texto.slice(posicao + termo.length))
        },
    },
    created(){
        this.carregar()
    },
    mounted(){
        document.body.appendChild(this.$refs.painel)
    },
    beforeDestroy(){
        this.fechar()
        if(this.$refs.painel && this.$refs.painel.parentNode) this.$refs.painel.parentNode.removeChild(this.$refs.painel)
    },
}
</script>

<style lang="scss">
@import '../../../sass/variables';

// ----- gatilho -----
.su { min-width: 0; }

.su__gatilho {
    display: flex;
    align-items: center;
    gap: .55rem;
    width: 100%;
    min-width: 0;
    border: 0;
    font: inherit;
    text-align: left;
    cursor: pointer;
    transition: background-color .15s ease, box-shadow .15s ease;

    &:focus { outline: none; }
}

.su__avatar {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 1.6rem;
    height: 1.6rem;
    border-radius: .45rem;
    font-size: .65rem;
    font-weight: 700;
    letter-spacing: .02em;
    color: #fff;
    background: $ec-turquesa;

    &--item { width: 2rem; height: 2rem; font-size: .72rem; border-radius: .55rem; }
}

.su__gatilho-textos {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    line-height: 1.25;
}

.su__gatilho-nome {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-weight: 600;
}

.su__gatilho-empresa {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: .7rem;
    opacity: .7;
}

.su__seta {
    flex-shrink: 0;
    font-size: .65rem;
    transition: transform .2s ease;
}

.su__gatilho--aberto .su__seta { transform: rotate(180deg); }

// barra superior: pílula clara
.su--barra {
    display: inline-block;
    max-width: 320px;

    .su__gatilho {
        padding: .2rem .7rem .2rem .25rem;
        border-radius: 999px;
        background: rgba($ec-turquesa, .08);
        color: $ec-turquesa;
        font-size: .8rem;

        &:hover, &.su__gatilho--aberto { background: rgba($ec-turquesa, .16); }
        &:focus-visible { box-shadow: 0 0 0 2px rgba($ec-turquesa, .35); }
    }

    .su__avatar { width: 1.45rem; height: 1.45rem; border-radius: 50%; font-size: .58rem; }
}

// menu lateral: cartão translúcido sobre o fundo escuro
.su--lateral {
    .su__gatilho {
        padding: .45rem .55rem;
        border-radius: .6rem;
        background: rgba(#fff, .06);
        border: 1px solid rgba(#fff, .1);
        color: #fff;
        font-size: .85rem;

        &:hover, &.su__gatilho--aberto { background: rgba(#fff, .12); border-color: rgba($ec-ciano, .35); }
        &:focus-visible { box-shadow: 0 0 0 2px rgba($ec-ciano, .5); }
    }

    .su__gatilho-nome { white-space: normal; display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; }
    .su__seta { color: $ec-ciano; }
}

// ----- painel -----
.su-painel {
    position: fixed;
    z-index: 1055;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: $ec-superficie;
    border: 1px solid $ec-borda;
    border-radius: .75rem;
    box-shadow: 0 12px 32px rgba($ec-petroleo-profundo, .18), 0 2px 6px rgba($ec-petroleo-profundo, .08);
    color: $ec-texto;
    text-align: left;
    animation: su-entrar .14s ease-out;

    kbd {
        display: inline-block;
        padding: .05rem .3rem;
        border: 1px solid $ec-borda;
        border-bottom-width: 2px;
        border-radius: .25rem;
        background: $ec-fundo;
        color: $ec-texto-suave;
        font-family: inherit;
        font-size: .65rem;
        font-weight: 600;
        box-shadow: none;
    }
}

@keyframes su-entrar {
    from { opacity: 0; transform: translateY(-4px); }
    to { opacity: 1; transform: none; }
}

.su-painel__busca {
    display: flex;
    align-items: center;
    gap: .5rem;
    padding: .65rem .85rem;
    border-bottom: 1px solid $ec-borda;
    color: $ec-texto-suave;

    input {
        flex: 1;
        min-width: 0;
        border: 0;
        background: transparent;
        font-size: .875rem;
        color: $ec-texto;

        &:focus { outline: none; }
        &::-webkit-search-cancel-button { display: none; }
        &::placeholder { color: #a3b1b7; }
    }
}

.su-painel__limpar {
    border: 0;
    background: transparent;
    color: $ec-texto-suave;
    font-size: 1.1rem;
    line-height: 1;
    cursor: pointer;
}

.su-painel__lista {
    flex: 1;
    overflow-y: auto;
    padding: .35rem;
    overscroll-behavior: contain;
}

.su-painel__estado {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: .4rem;
    padding: 1.5rem 1rem;
    font-size: .8rem;
    color: $ec-texto-suave;
    text-align: center;
}

.su-grupo + .su-grupo { margin-top: .35rem; padding-top: .35rem; border-top: 1px solid $ec-borda; }

.su-grupo__titulo {
    display: flex;
    align-items: center;
    gap: .4rem;
    padding: .35rem .55rem .25rem;
    font-size: .66rem;
    font-weight: 700;
    letter-spacing: .06em;
    text-transform: uppercase;
    color: $ec-texto-suave;

    span:first-of-type { flex: 1; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
}

.su-grupo__contagem {
    padding: 0 .4rem;
    border-radius: 999px;
    background: $ec-fundo;
    font-size: .62rem;
}

.su-item {
    display: flex;
    align-items: center;
    gap: .65rem;
    width: 100%;
    padding: .45rem .55rem;
    border: 0;
    border-radius: .5rem;
    background: transparent;
    color: inherit;
    font: inherit;
    text-align: left;
    cursor: pointer;

    &:focus { outline: none; }

    &--foco { background: rgba($ec-turquesa, .08); }
    &--foco .su-item__ir { opacity: 1; transform: none; }

    &--atual .su-item__nome { color: $ec-turquesa; }
}

.su-item__textos {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    line-height: 1.3;
}

.su-item__nome {
    font-size: .84rem;
    font-weight: 600;
    overflow-wrap: anywhere;
}

.su-item__detalhe {
    font-size: .72rem;
    color: $ec-texto-suave;
}

.su-item mark {
    padding: 0;
    border-radius: .15rem;
    background: rgba(#f6c343, .45);
    color: inherit;
}

.su-item__marca { flex-shrink: 0; color: $ec-texto-suave; }

.su-item__marca--atual {
    padding: .05rem .45rem;
    border-radius: 999px;
    font-size: .65rem;
    font-weight: 700;
    color: $ec-turquesa;
    background: rgba($ec-turquesa, .1);
}

.su-item__ir {
    font-size: .75rem;
    opacity: 0;
    transform: translateX(-4px);
    transition: opacity .12s ease, transform .12s ease;
}

.su-painel__rodape {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: .5rem;
    padding: .45rem .85rem;
    border-top: 1px solid $ec-borda;
    background: $ec-fundo;
    font-size: .7rem;
    color: $ec-texto-suave;
}

.su-painel__atalhos kbd { margin: 0 .1rem; }

@media (max-width: 575.98px) {
    .su--barra { max-width: 200px; }
    .su-painel__atalhos { display: none; }
}

@media (prefers-reduced-motion: reduce) {
    .su-painel { animation: none; }
}
</style>
